// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, signInAnonymously, onAuthStateChanged } from "firebase/auth";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
// Fallback to hardcoded values if environment variables are not loaded
// This ensures the app doesn't break during development
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyD6yJj40eWEsm_f5_S2LZD5_GVhc5YqszE",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "digital-mindebog.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "digital-mindebog",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "digital-mindebog.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "357007968533",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:357007968533:web:9d43043264f5b3a6dac11c",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-FF7Y4TWD19"
};

// Check if Firebase config is valid
const isFirebaseConfigValid = () => {
  return firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId;
};

// Initialize Firebase
let app;
let db;
let storage;
let auth;
let functions;

try {
  if (isFirebaseConfigValid()) {
    app = initializeApp(firebaseConfig);
    db = getFirestore(app);
    storage = getStorage(app);
    auth = getAuth(app);
    functions = getFunctions(app);
  } else {
    console.error("Invalid Firebase configuration. Check your environment variables.");
  }
} catch (error) {
  console.error("Firebase initialization error:", error);
}

// Function to ensure user is authenticated
export const ensureAuthenticated = () => {
  if (!auth) {
    return Promise.reject(new Error("Firebase Auth not initialized"));
  }
  
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      if (user) {
        resolve(user);
      } else {
        // Sign in anonymously if not already signed in
        signInAnonymously(auth)
          .then((userCredential) => {
            resolve(userCredential.user);
          })
          .catch((error) => {
            console.error("Error signing in anonymously:", error);
            reject(error);
          });
      }
    });
  });
};

// Export so we can use it elsewhere
export { db, storage, auth, functions };
